import styled from 'styled-components'

import { TypeStyle, fromLg } from '@syconium/little-miss-figgy'

export const Container = styled.div`
  color: ${o => o.theme.color.stroke.neutral.text.tertiary.on.background};
`

export const MobileView = styled.div`
  display: flex;
  justify-content: center;
  ${fromLg} {
    display: none;
  }
`

export const MobileText = styled(TypeStyle.BodyMedium).attrs({ asTag: 'span' })`
  font-weight: ${o => o.theme.typography.font.weight[700]};
  line-height: 21px;
`

export const DesktopView = styled.div`
  display: none;
  ${fromLg} {
    display: flex;
  }
`
export const DesktopTitle = styled(TypeStyle.BodyMedium).attrs({ asTag: 'span' })`
  font-weight: ${o => o.theme.typography.font.weight[700]};
  line-height: 21px;
`

export const List = styled.ul``
export const ListItem = styled.li``

export const ListItemTitle = styled(TypeStyle.BodyMedium).attrs({ asTag: 'span' })`
  font-weight: ${o => o.theme.typography.font.weight[400]};
  line-height: 21px;
`
